"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSearchResult = exports.convertSearchResult = void 0;
/**
 * @deprecated use remota-server/util/search
 */
function convertSearchResult(result, mapper) {
    var items = result.items, cursor = result.cursor, count = result.count;
    return { items: items.map(mapper), cursor: cursor, count: count };
}
exports.convertSearchResult = convertSearchResult;
/**
 * @deprecated use remota-server/util/search
 */
function toSearchResult(items) {
    return { items: items, cursor: null, count: items.length };
}
exports.toSearchResult = toSearchResult;
